import React, { forwardRef } from 'react';
import { useSpacing } from '../../api/spacing/useSpacing';
import { pickAriaProps, pickComponentCommonProps, } from '../../interfaces/commonProps';
import { StyledBadgeContainer, StyledBadgeCount } from './Badge.styles';
export const Badge = forwardRef(function Avatar({ count, 'aria-label': ariaLabel = `${count !== undefined ? count : 1} new notifications`, ...restProps }, ref) {
    const outerSpacing = useSpacing(restProps);
    const commonProps = pickComponentCommonProps(restProps);
    const ariaProps = pickAriaProps(restProps);
    return (React.createElement(StyledBadgeContainer, { ref: ref, role: "status", "aria-label": ariaLabel, variant: count ? 'number' : 'dot', outerSpacing: outerSpacing, ...commonProps, ...ariaProps }, count !== undefined && count > 0 && (React.createElement(StyledBadgeCount, null, count > 99 ? '99+' : count))));
});
//# sourceMappingURL=Badge.js.map